module.exports = __webpack_public_path__ + "img/05.d758b238.jpg";